import React from 'react';
import { Box } from '@mui/material';
import { AccountNavigatorTree } from '../../../components/tree/AccountNavigatorTree';
import { useCurrentBankAccountOrThrow } from '../../../redux/bank-accounts/CurrentAccountHook';

export interface CurrentAccountNavigatorProps {
  onTreeItemClicked?: (uuid: string) => void;
}

export const CurrentAccountNavigator = (
  props: CurrentAccountNavigatorProps,
) => {
  const { onTreeItemClicked } = props;

  const account = useCurrentBankAccountOrThrow();

  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        padding: (theme) => theme.spacing(0, 1),
      }}
    >
      <AccountNavigatorTree
        lines={account.operations}
        onTreeItemClicked={onTreeItemClicked}
      />
    </Box>
  );
};
